import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { ApiError, AuthService, MessageService } from '../../../core';
import { UsuarioFilter } from '../filter';
import { UsuarioCrudHttpService } from '../services';
import { Usuario } from '../usuario';
import { usuarioAtivo } from '../usuario-situacao';

@Component({
    selector: 'sgt-usuario-select',
    templateUrl: './usuario-select.component.html',
    styleUrls: ['./usuario-select.component.less']
})
export class UsuarioSelectComponent implements OnInit, OnChanges {
    idUsuarioLogado: number;

    /** ID do usuário selecionado */
    @Input() idUsuario: number;
    /** Ao alterar o usuário selecionado */
    @Output() idUsuarioChange = new EventEmitter<number>();
    /** Usuário selecionado */
    usuario: Usuario;
    /** Usuário alterado */
    @Output() usuarioChange = new EventEmitter<Usuario>();

    /** Nome para exibir quando não possuir um usuário selecionado */
    @Input() empityName = 'Nenhum usuário';

    @Input() disabled: boolean;

    /** Filtro de pesquisa dos usuários */
    filter: string;
    /** Usuários disponíveis para seleção */
    usuarios: Usuario[] = [];

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private usuarioCrudHttpService: UsuarioCrudHttpService) { }

    async ngOnInit(): Promise<void> {
        this.idUsuarioLogado = this.authService.getIdUsuario();

        Promise.all([
            this.search(),
            this.findUsuario()
        ])
        .then(values => {
            this.usuarios = values[0];
            this.usuario = values[1];
        })
        .catch(() => {});
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        for (const propName in changes) {
            if (propName === 'idUsuario') {
                if (changes[propName].isFirstChange()) {
                    return;
                }

                if (this.idUsuario) {
                    this.usuario = await this.findUsuario();
                }
            }
        }
    }

    /** Carrega o usuário atual */
    private findUsuario(): Promise<Usuario> {
        return new Promise<Usuario>((resolve, reject) => {
            if (!this.idUsuario) {
                resolve(null);
                return;
            }

            this.usuarioCrudHttpService.find(this.idUsuario)
                .pipe(
                    take(1)
                )
                .subscribe(
                    usuario => resolve(usuario),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o usuário selecionado', error);
                        reject();
                    }
                );
        });
    }

    /** Pesquisa os usuários */
    private search(): Promise<Usuario[]> {
        return new Promise<Usuario[]>((resolve, reject) => {
            const filter = new UsuarioFilter();
            // Somente Ativos
            filter.situacao = usuarioAtivo.id;

            this.usuarioCrudHttpService.searchWithFilter(filter, null, null, null, null, null)
                .pipe(
                    take(1)
                )
                .subscribe(
                    response => resolve(response.data ?? []),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar os usuários', error);
                        reject();
                    }
                );
        });
    }

    /** Ao selecionar um usuário */
    select(usuario: Usuario) {
        this.idUsuario = usuario ? usuario.id : null;
        this.idUsuarioChange.emit(this.idUsuario);
        this.usuario = usuario;
        this.usuarioChange.emit(usuario);
        this.filter = null;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }
}
